import api from './api';

export async function searchUsers(query) {
  const response = await api.get('/api/users/search', { params: { query } });
  return response.data;
}
